import {z} from 'zod';

export const SendCustomerSmsFormSchema = z.object({
  customerId: z.string().min(1),
  body: z.string().min(1),
  phoneNumber: z.string().min(1),
});

export type FormValues = z.infer<typeof SendCustomerSmsFormSchema>;
